export default "__VITE_ASSET__D0eSJOCn__"